// extracted by mini-css-extract-plugin
export default {"h1":"styles_h1__l2BW9","h2":"styles_h2__MVyJ4","h3":"styles_h3__tAKYs"};